// eslint-disable-next-line no-restricted-imports
import {
  MutationInput_LegalClientController_UpdateById_Input_ServiceContract_Type as LegalClientServiceContractTypeApi1,
  SaveLegalClientServiceContractByAdminDto_Input,
} from 'api/generated/graphql';
import { ServiceContractType } from 'api/types/entity';
import { ServiceContractParam } from 'api/types/params';
import { formatToISODate } from 'helpers';

type LegalClientServiceContractTypeApi = LegalClientServiceContractTypeApi1;

const legalClientServiceContract: Record<
  ServiceContractType,
  LegalClientServiceContractTypeApi
> = {
  [ServiceContractType.AdditionalAgreementToCustodialContract]:
    LegalClientServiceContractTypeApi1.AdditionalAgreementToCustodialContract,
  [ServiceContractType.BrokerageServicesContract]:
    LegalClientServiceContractTypeApi1.BrokerageServicesContract,
  [ServiceContractType.BrokerageServicesContractWithNominalHolding]:
    LegalClientServiceContractTypeApi1.BrokerageServicesContractWithNominalHolding,
  [ServiceContractType.ConsultancyServicesContract]:
    LegalClientServiceContractTypeApi1.ConsultancyServicesContract,
  [ServiceContractType.CustodialContract]:
    LegalClientServiceContractTypeApi1.CustodialContract,
  [ServiceContractType.InvestmentPortfolioManagementContract]:
    LegalClientServiceContractTypeApi1.InvestmentPortfolioManagementContract,
  [ServiceContractType.MarketMakerServicesContract]:
    LegalClientServiceContractTypeApi1.MarketMakerServicesContract,
  [ServiceContractType.SupplementaryAgreement]:
    LegalClientServiceContractTypeApi1.SupplementaryAgreement,
  [ServiceContractType.UnderwritingServicesContract]:
    LegalClientServiceContractTypeApi1.UnderwritingServicesContract,
};

export const parseLegalClientServiceContractParam = (
  data: ServiceContractParam | undefined | null
): SaveLegalClientServiceContractByAdminDto_Input => ({
  type: data?.type ? legalClientServiceContract[data.type] : undefined,
  number: data?.number ?? undefined,
  conclusionDate: data?.conclusionDate
    ? formatToISODate(data.conclusionDate)
    : null,
  terminationDate: data?.terminationDate
    ? formatToISODate(data.terminationDate)
    : null,
  fileId_Finance: data?.fileId_Finance || null,
});
